exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active,\n.fade-leave-active {\n  transition: opacity 0.6s;\n}\n.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {\n  opacity: 0;\n}\n.list-enter-active,\n.list-leave-active {\n  transition: all 0.3s ease-in-out;\n}\n.list-enter {\n  transform: translateY(-30px);\n  opacity: 0;\n}\n.list-leave-to {\n  opacity: 0;\n  transform: translateY(-30px);\n}\n.vc-pane-container {\n  padding: 0.4em;\n}\n\n/* Hide the date on the timepicker custom fields */\n.timepicker-field .vc-date {\n  display: none;\n}\n#map {\n  width: 100%;\n  height: 50vh;\n}\n", ""]);

// exports
